import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getSlateColorToken } from "@faire/retailer-shared/SlateMappings/getSlateColorToken";
import { LoadableTypography } from "@faire/retailer-visitor-shared/components/GhostLoading/LoadableTypography";
import { Row } from "@faire/web--source/slate/Layout";
import { getSlateIcon } from "@faire/web--source/slate/SlateMappings/getSlateIcon";
import { NoTranslate } from "@faire/web--source/ui/lib/localization";
import classNames from "classnames";
import React from "react";
export var BrandNameText = function(param) {
    var brandToken = param.brandToken, brandName = param.brandName, brandIcon = param.brandIcon, isLoaded = param.isLoaded, _param_withLink = param.withLink, withLink = _param_withLink === void 0 ? true : _param_withLink;
    var BrandIcon = getSlateIcon(brandIcon);
    var brandNameSection = /*#__PURE__*/ _jsxs(Row, {
        align: "center",
        gap: "1/4x",
        children: [
            brandIcon ? /*#__PURE__*/ _jsx(BrandIcon, {
                "data-test-id": "brand-icon",
                fontSize: "12px",
                color: getSlateColorToken(brandIcon.color_token),
                titleAccess: ""
            }) : null,
            /*#__PURE__*/ _jsx(LoadableTypography, {
                isLoaded: isLoaded,
                variant: !withLink ? "paragraphSansMedium" : "paragraphSansRegular",
                maxLines: 1,
                className: "break-all",
                children: /*#__PURE__*/ _jsx(NoTranslate, {
                    children: /*#__PURE__*/ _jsx("span", {
                        className: classNames(!withLink ? "overflow-hidden pt-1 hover:underline" : ""),
                        children: brandName
                    })
                })
            })
        ]
    });
    if (!brandToken) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Row, {
        className: classNames(!withLink ? "" : "overflow-hidden pt-1 underline"),
        justify: "space-between",
        children: brandNameSection
    });
};
